// src/Ca.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Ca_default = createIcon({
  displayName: "Ca",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("path", {
        id: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 1V33H49.5V1H1.5Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 1V33H10.5V1H1.5Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40.5 1V33H49.5V1H40.5Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "emblem",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.2496 7L23.5467 10.1671C23.3535 10.5113 23.0072 10.4794 22.661 10.2872L21.4281 9.65057L22.347 14.5152C22.5403 15.404 21.9203 15.404 21.6143 15.0197L19.4627 12.6178L19.1134 13.8376C19.0731 13.9977 18.896 14.166 18.6303 14.1259L15.9096 13.5555L16.6242 16.1462C16.7772 16.7226 16.8965 16.9613 16.4698 17.1133L15.5 17.5678L20.1836 21.3613C20.3689 21.5047 20.4626 21.7628 20.3966 21.9966L19.9867 23.3379C21.5993 23.1526 23.0442 22.8737 24.6577 22.702C24.8001 22.6868 25.0386 22.9212 25.0376 23.0858L24.8239 28H25.608L25.4846 23.0963C25.4836 22.9317 25.6999 22.6868 25.8423 22.702C27.4558 22.8737 28.9007 23.1526 30.5133 23.3379L30.1034 21.9966C30.0374 21.7628 30.1311 21.5047 30.3164 21.3613L35 17.5678L34.0302 17.1133C33.6035 16.9613 33.7228 16.7226 33.8758 16.1462L34.5904 13.5555L31.8697 14.1259C31.604 14.166 31.4269 13.9977 31.3866 13.8376L31.0373 12.6178L28.8857 15.0197C28.5797 15.404 27.9597 15.404 28.153 14.5152L29.0718 9.65057L27.839 10.2872C27.4928 10.4794 27.1465 10.5113 26.9533 10.1671L25.2496 7Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Ca_default
};
